export enum ScreenState {
  CREATE = 'create',
  CARD_LIST = 'cardList',
}

export interface SmsState {
  activeSteps: number[]
  screen: ScreenState
}
